import { useState } from "react";
import { login } from "../services/authService";
import LoginForm from "../components/LoginForm";
import { useNavigate } from "react-router-dom";
import Layout from "../pages/Layout";
import { Helmet } from "react-helmet";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (formData) => {
    setLoading(true);
    setMessage("");

    const result = await login(formData);

    if (result.success) {
      setMessage(result.message);
      localStorage.setItem("token", result.token); // ✅ Save JWT Token
      navigate("/"); // ✅ Redirect to dashboard
    } else {
      setMessage(result.message);
    }

    setLoading(false);
  };

  return (
    <div>
      <Helmet>
        <title>Login - Factbazaar</title>
        <meta name="description" content="Login to the best news platform for latest updates!" />
      </Helmet>
       <Layout>
      <LoginForm onSubmit={handleLogin} loading={loading} />
      {message && (
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="alert alert-danger mt-3 text-center" role="alert">
              {message}
            </div>
          </div>
        </div>
      )}
</Layout>
    </div>
  );
};

export default Login;
